import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BehaviorSubject, Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {BusinessProcessService} from '../../../../../services/business-process.service';
import {EditFieldsService} from '../../../../../services/edit-fields.service';

@Component({
  selector: 'app-field-detail',
  templateUrl: './fields-multiple-edition.component.html',
  styleUrls: ['./fields-multiple-edition.component.css', '../../../../../styles/business-process-configuration.css']
})
export class FieldsMultipleEditionComponent implements OnInit {

  @Input() modalTitle: string;

  itemSaved: Subject<any>;
  fieldDetailForm: FormGroup;

  enumFieldType: any[];
  enumDateExhibitionFormat: any[];
  enumFieldValidator: any[];
  enumMaskType: any[];
  fieldInfo: any
  countSelectedFields = 0;
  availableStates = [];
  selectedStatesxistingConfig = [];
  selectedStates = [];
  objInitialState;
  public disableMultiselectState$: BehaviorSubject<any>;


  get formData() { return this.fieldDetailForm.controls; }

  constructor(public bsModalRef: BsModalRef, private formBuilder: FormBuilder, private bpService: BusinessProcessService, private editFieldsService: EditFieldsService) { }

  ngOnInit() {
    if (this.objInitialState){
      this.availableStates = this.objInitialState.availableStates;
      this.countSelectedFields = this.objInitialState.countSelectedFields;
    }
    this.disableMultiselectState$ = new BehaviorSubject<any>(true);

    this.getEnumArray();

    this.itemSaved = new Subject()
    this.fieldInfo = {};
    this.createForm();
    this.loadFieldData();
  }

  getEnumArray() {
    let arrays = this.editFieldsService.getEnumArrays();

    this.enumFieldType = arrays.fieldType;
    this.enumFieldType = this.enumFieldType.filter(item => item.key !== '6');

    this.enumDateExhibitionFormat = arrays.dateExibitionFormat;
    this.enumFieldValidator = arrays.fieldValidator;
  }

  createForm() {
    this.fieldDetailForm = this.formBuilder.group({
      displayName: new FormControl({value: '', disabled: true}, [Validators.maxLength(100)]),
      chkDisplayName: false,
      description: new FormControl({value: '', disabled: true}, [Validators.maxLength(100)]),
      chkDescription: false,
      type: new FormControl({value: 0, disabled: true}),
      chkType: false,
      length: null,
      dateExibitionFormat: 1,
      maskType: 0,
      isRequired: new FormControl({value: false, disabled: true}),
      chkRequired: false,
      isTrackable: new FormControl({value: false, disabled: true}),
      chkTrackable: false,
      validator: new FormControl({value: 0, disabled: true}),
      chkValidator: false,
      chkStates: false
    });
  }

  loadFieldData() {
    this.fieldInfo['displayName'] = "";
    this.fieldInfo['description'] = "";
    this.fieldInfo['type'] = 1;
    this.fieldInfo['length'] = null;
    this.fieldInfo['dateExibitionFormat']=0;
    this.fieldInfo['isTrackable'] = false;
    this.fieldInfo['isRequired'] = false;
    this.fieldInfo['validator'] = 0;
    this.fieldInfo['maskType'] = 0;

    this.fieldDetailForm.patchValue({
      displayName: this.fieldInfo['displayName'],
      description: this.fieldInfo['description'],
      type: this.fieldInfo['type'],
      length: this.fieldInfo['length'],
      dateExibitionFormat: this.fieldInfo['dateExibitionFormat'],
      isTrackable: this.fieldInfo['isTrackable'],
      isRequired: this.fieldInfo['isRequired'],
      validator: this.fieldInfo['validator'],
      maskType: this.fieldInfo['maskType']
    });
  }

  onFieldTypeChange(element) {
    const selectedType = parseInt(element.target.value, 10);
    let result = this.editFieldsService.changeFieldType(this.fieldDetailForm, selectedType)
    this.enumMaskType = result.enumMaskType;
    this.resetTypeDependenciesValues();
    if (selectedType === 5){
      this.formData.chkValidator.setValue(false);
      this.formData.validator.setValue(0);
      this.formData.validator.disable();
    }
  }

  onChkRequiredChanged() {
    if (this.formData.chkRequired.value){
      this.formData.isRequired.enable();
    } else {
      this.formData.isRequired.disable();
      this.formData.isRequired.setValue(false);
    }
  }

  onChkTrackableChanged() {
    if (this.formData.chkTrackable.value){
      this.formData.isTrackable.enable();
    } else {
      this.formData.isTrackable.disable();
      this.formData.isTrackable.setValue(false);
    }
  }

  getSelectedStates(element) {
    this.selectedStates = element;
  }

  onChkStatesChanged() {
    this.disableMultiselectState$.next(!this.formData.chkStates.value);
  }

  onChkTypeChanged() {
    if (this.formData.chkType.value) {
      if (!this.formData.type.value){
        this.formData.type.setValue(1);
      }
      this.formData.type.enable();
    }
    else {
      this.formData.type.disable();
      this.formData.type.setValue(1);
      this.resetTypeDependenciesValues();
    }
  }

  resetTypeDependenciesValues(){
    this.formData.dateExibitionFormat.setValue(0);
    this.formData.length.setValue(null);
    this.formData.maskType.setValue(0);
  }

  getIntValue(stringValue){
    if (stringValue){
      return  parseInt(stringValue, 10);
    }
    return 0;
  }

  onSave() {
    const data = this.fieldDetailForm.getRawValue();
    data.stateIdsInWhichIsEditable = this.selectedStates;
    data.type = this.getIntValue(data.type);
    data.dateExibitionFormat = this.getIntValue(data.dateExibitionFormat);
    data.maskType = this.getIntValue(data.maskType);
    data.validator = this.getIntValue(data.validator);
    data.length = this.getIntValue(data.length);

    this.itemSaved.next(data);
    this.bsModalRef.hide();
  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }
}
